import React, { FC, useEffect } from "react";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { experiences_type } from "data/experiences_type";
import { selectCurrentExperience, setExperience } from "application/features/experience/experienceSlice";
import Textarea from "shared/Textarea/Textarea";
import Label from "components/Label/Label";
import { useTranslation } from "react-i18next";
import InfoTooltip from "components/Quasi/InfoTooltip/InfoTooltip";

export interface PageAddListing1Props { }

const PageAddExperience1: FC<PageAddListing1Props> = () => {

  const { t, ready } = useTranslation("translation");

  const experience = useSelector(selectCurrentExperience)

  const dispatch = useDispatch()

  const handleUpdateProperty = async (field: string, value: any) => {
    dispatch(setExperience({ ...experience, [field]: value }))
  };

  useEffect(() => {
    dispatch(setExperience({ ...experience, mood: "business" }))
  }, [])

  if (!ready) return null;

  return (
    <CommonLayout
      index="01"
      backtHref="/host/new-listing/"
      nextHref={`/host/new-experience/add-listing-2`}
      canGoNext={experience?.name?.length > 0 && experience?.description?.length > 0 && experience?.type?.length > 0}
    >
      <>
        <h2 className="text-2xl font-semibold">{t("translation:components.experienceUploadForm.page1.title")}</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          {/* ITEM */}
          <FormItem
            label="Scegli l’esperienza"
            desc=""
          >
            <Select
              value={experience?.type || ""}
              onChange={(e) => handleUpdateProperty("type", e.target.value)}
            >
              <option defaultChecked value={""}>Seleziona</option>
              {
                experiences_type.map((item: any, index: Number) => (
                  <option key={item.id} value={item.value}>{item.label}</option>
                ))
              }
            </Select>
          </FormItem>
          <FormItem
            label="Nome dell'annuncio"
            desc="Un nome accattivante di solito include: Attività + Destinazione turistia"
          >
            <Input
              value={experience?.name || ""}
              onChange={(e) => handleUpdateProperty("name", e.target.value)}
              placeholder="Nome"
              maxLength={255}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Mood:
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.mood" />
              </span>
            }
            desc="Business:Posizione centrale pensato per chi viaggia per lavoro. Comfort: Posizione comoda pensato per il relax. Authentic: zone autentiche per esperienze uniche."
          >
            <div className="my-2">
              <Label>Seleziona uno di questi mood per far identificare più velocemente il target specifico a cui ti rivolgi. Il tuo annuncio sarà visibile a tutti, ma si potrà caratterizzare e ti potrà aiutare ad attirare il target a te più congeniale</Label>
            </div>

            <Select
              value={experience?.mood || "business"}
              onChange={(e) => handleUpdateProperty("mood", e.target.value)}
            >
              <option value="business">Business</option>
              <option value="comfort">Comfort</option>
              <option value="authentic">Authentic</option>
            </Select>
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Descrizione
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.descrizione" />
              </span>
            }
            desc="Descrivi la tua esperienza, includi informazioni utili per gli ospiti come: cosa faranno, cosa impareranno, cosa vedranno, cosa mangeranno, ecc."
          >
            <Textarea
              value={experience?.description || ""}
              onChange={(e) => handleUpdateProperty("description", e.target.value)}
              placeholder="descrizione..."
              maxLength={5000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Cosa aspettarsi
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.cosa_aspettarsi" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.expect || ""}
              onChange={(e) => handleUpdateProperty("expect", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Cosa vedrai
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.cosa_vedrai" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.what_to_see || ""}
              onChange={(e) => handleUpdateProperty("what_to_see", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Cosa è incluso
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.cosa_è_incluso" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.included || ""}
              onChange={(e) => handleUpdateProperty("included", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Cosa non è incluso
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.cosa_non_è_incluso" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.not_included || ""}
              onChange={(e) => handleUpdateProperty("not_included", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Servizi accessori acquistabili
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.servizi_accessori_acquistabili" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.addons || ""}
              onChange={(e) => handleUpdateProperty("addons", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Cosa indossare
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.cosa_indossare" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.what_to_wear || ""}
              onChange={(e) => handleUpdateProperty("what_to_wear", e.target.value)}
              placeholder="descrizione..."
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Livello di difficoltà
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.livello_di_difficoltà" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.difficulty || ""}
              onChange={(e) => handleUpdateProperty("difficulty", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>
          <FormItem
            labelNode={
              <span className="inline-flex items-center">
                Punto e orario di incontro
                <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.punto_e_orario_di_incontro" />
              </span>
            }
            desc=""
          >
            <Textarea
              value={experience?.meeting_point || ""}
              onChange={(e) => handleUpdateProperty("meeting_point", e.target.value)}
              placeholder="descrizione..."
              maxLength={1000}
            />
          </FormItem>

        </div>
      </>
    </CommonLayout >
  );
};

export default PageAddExperience1;
